'use client'

import { Box, Button, Typography } from '@mui/material'

export interface HotelCenteredMessageProps {
    title: string
    subtitle?: string
    /** Optional action button (e.g. "Go back"); rendered only when both are provided. */
    actionLabel?: string
    onAction?: () => void
    /** Vertical fill; defaults to the desktop viewport minus the fixed header. */
    minHeight?: string | number
    /** Fill the parent flex column (flex:1) instead of using minHeight. */
    fill?: boolean
}

// Shared centered error/empty state for the hotel pages — replaces the flex-column block
// that was inlined across the results, details, itinerary, guest-details and confirmation
// containers on both platforms.
const HotelCenteredMessage: React.FC<HotelCenteredMessageProps> = ({
    title,
    subtitle,
    actionLabel,
    onAction,
    minHeight = 'calc(100vh - 54px)',
    fill = false
}) => (
    <Box
        sx={{
            ...(fill ? { flex: 1 } : { minHeight }),
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 1,
            px: 3,
            textAlign: 'center',
            bgcolor: 'neutral.100'
        }}
    >
        <Typography sx={{ fontSize: 18, fontWeight: 700, color: 'textColors.primary' }}>{title}</Typography>
        {subtitle && <Typography sx={{ fontSize: 14, color: 'textColors.secondary' }}>{subtitle}</Typography>}
        {actionLabel && onAction && (
            <Button variant="customVariantPrimary" onClick={onAction} sx={{ mt: 2, px: 4 }}>
                {actionLabel}
            </Button>
        )}
    </Box>
)

export { HotelCenteredMessage }
export default HotelCenteredMessage
